import { baseUrl } from '@/service/util';
import request from '@/utils/request';

/**
 * 查询普通产品列表
 */
export const getMemberListProducts = (params: { variantIds: string[] }, locale: string) =>
    request.post(`${baseUrl(locale)}/ProductCaculation/productInfoList`, {
        data: params,
        needToken: true,
    });
